import { render } from "./ModalEditarRequisito.vue?vue&type=template&id=30a86e46&scoped=true"
import script from "./ModalEditarRequisito.vue?vue&type=script&lang=js"
export * from "./ModalEditarRequisito.vue?vue&type=script&lang=js"

import "./ModalEditarRequisito.vue?vue&type=style&index=0&id=30a86e46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a86e46"]])

export default __exports__